import { gql } from '@apollo/client'

export const GET_ENABLED_FEATURE_FLAGS = gql`
  query GetEnabledFeatureFlags {
    enabledFeatureFlags
  }
`
